export default __webpack_public_path__ + "static/media/user_interface.073c4b81.svg";